import { useMutation, useQueryClient } from '@tanstack/react-query';
import { chestService } from '@services';
import { USER_PROFILE_QUERY_KEY } from './useUserProfile';
import { UNOPENED_CHESTS_QUERY_KEY } from './useUnopenedChests';
import { useAuthStore } from '@app/stores';

export const useOpenChest = () => {
  const queryClient = useQueryClient();
  const validateAndUpdateUser = useAuthStore(
    (state) => state.validateAndUpdateUser
  );

  return useMutation({
    mutationFn: (chestId: string) => chestService.openChest(chestId),
    onSuccess: async () => {
      // Refetch
      await queryClient.invalidateQueries({ queryKey: USER_PROFILE_QUERY_KEY });
      await queryClient.invalidateQueries({ queryKey: UNOPENED_CHESTS_QUERY_KEY });

      // Update auth store
      await validateAndUpdateUser();
    },
  });
};
